import {
    ANALYTICS_CHANNEL,
    CHANNEL_INFO_BY_CHANNEL,
    CHANNEL_TYPE_ECOMMERCE,
    CHANNEL_TYPE_PAID_MEDIA,
} from '../../channels/channels';

/**
 * Las fuentes que un cliente DEBERÍA tener vinculadas y no tiene (card RNAjmiW6).
 *
 * A Dashbo le importa que la agencia conecte todo lo del cliente: más contexto para la IA. Hasta
 * esta card el Panel sólo ofrecía «sugeridas» sin decir que alguna faltaba, y en Not Ordinary 1 de
 * 34 líneas tenía GA4. La regla es deliberadamente corta:
 *
 * - **GA4**: siempre, sea ecommerce o leads.
 * - **La tienda**: sólo si el perfil dice que vende online (`ECOMMERCE`). Con el tipo sin cargar u
 *   `OTHER` no se pide: insistir sobre un dato incierto es ruido.
 * - **Pauta**: si no hay NINGUNA cuenta de pauta. No hay forma de saber «qué plataforma usa» el
 *   cliente, así que no se pide cada una.
 *
 * Un canal que la agencia no habilitó (`channels`) o que alguien ignoró a propósito sale de la
 * regla: «Ignorar» es la salida para quien no lo usa. La tienda se pide como UNA entrada genérica
 * —el modal de tiendas deja elegir la plataforma—, con el primer canal de tienda habilitado.
 *
 * Devuelve `[{key, channel}]` en el orden en que se muestran; `channel` es `null` cuando la salida
 * no es un canal puntual (pauta).
 */
export function missingExpectedPlatforms({channels, accountsByChannel, ignoredChannels, businessType}) {
    const enabled = (channels || []).filter(ch => CHANNEL_INFO_BY_CHANNEL[ch]);
    const ignored = new Set((ignoredChannels || []).map(ic => ic.channel));
    const hasAccounts = (ch) => !!(accountsByChannel[ch] && accountsByChannel[ch].length > 0);
    const ofType = (type) => enabled.filter(ch => CHANNEL_INFO_BY_CHANNEL[ch]?.channelType === type);
    const missing = [];

    if (enabled.includes(ANALYTICS_CHANNEL) && !hasAccounts(ANALYTICS_CHANNEL) && !ignored.has(ANALYTICS_CHANNEL)) {
        missing.push({key: 'ga4', channel: ANALYTICS_CHANNEL});
    }

    if (businessType === 'ECOMMERCE') {
        const stores = ofType(CHANNEL_TYPE_ECOMMERCE);
        const offerable = stores.filter(ch => !ignored.has(ch));
        if (!stores.some(hasAccounts) && offerable.length > 0) {
            missing.push({key: 'store', channel: offerable[0]});
        }
    }

    const ads = ofType(CHANNEL_TYPE_PAID_MEDIA);
    if (ads.length > 0 && !ads.some(hasAccounts) && ads.some(ch => !ignored.has(ch))) {
        missing.push({key: 'ads', channel: null});
    }

    return missing;
}
